"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Flash = function Flash(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    height: "40",
    width: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.444,9.27C20.358,9.104,20.187,9,20,9h-7.376l1.864-8.394c0.061-0.269-0.109-0.537-0.378-0.598 c-0.196-0.044-0.4,0.034-0.517,0.198l-10,14c-0.162,0.223-0.113,0.536,0.11,0.698C3.79,14.967,3.893,15.001,4,15h7.376l-1.864,8.39 c-0.061,0.269,0.109,0.537,0.378,0.598c0.196,0.044,0.4-0.034,0.517-0.198l10-14C20.516,9.637,20.53,9.437,20.444,9.27z",
    fill: fill,
    stroke: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Flash.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Flash.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Flash;